import { firestore, firebaseApp } from '../main';

export default {
  namespaced: true,
  state: {
    notifications: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null
  },
  mutations: {
    RECEIVED_NOTIFICATIONS(state, payload) {
      state.notifications = payload;
      state.isReceiving = false;
    },
    RECEIVING_NOTIFICATIONS(state) {
      state.isReceiving = true;
    },
    UPDATED_NOTIFICATION(state, payload) {
      let index = state.notifications.findIndex(p => p.id === payload.id);
      if (index == -1) {
        state.notifications = [...state.notifications, payload];
      }
      state = Object.assign(state, {
        notifications: state.notifications.map((p, i) => {
          if (i === index) {
            return Object.assign({}, p, payload);
          }
          return p;
        }),
        isUpdating: false
      });
    },
    UPDATING_NOTIFICATION(state) {
      state.isUpdating = true;
    },
    DELETED_NOTIFICATION(state, payload) {
      let indexToDelete = state.notifications.findIndex(p => p.id === payload.id);
      let notifications = [...state.notifications];
      notifications.splice(indexToDelete, 1);
      state = Object.assign(state, {
        notifications: [...notifications],
        isDeleting: false,
        idToDelete: null
      });
    },
    DELETING_NOTIFICATION(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    }
  },
  actions: {
    async getNotificationsRequest({ dispatch }, selectedCountry) {
      dispatch('receivingNotifications');
      const snapshot = await firestore
        .collection('notifications')
        .where('tenantId', '==', selectedCountry)
        .get();
      const notifications = snapshot.docs.map(doc => Object.assign({}, doc.data(), { id: doc.id }));
      dispatch('receiveNotifications', notifications);
    },
    async updateNotificationRequest({ dispatch }, payload) {
      dispatch('updatingNotification');
      const notificationRef = await firestore
        .collection('notifications')
        .doc(payload.id)
        .set(payload.notification, { merge: true });
      payload.$toasted.success('Notification has been updated!');
      dispatch('updateNotification', payload.notification);
    },
    async createNotificationRequest({ dispatch }, payload) {
      dispatch('updatingNotification');
      const notificationRef = await firestore.collection('notifications').add(payload.notification);
      const notificationSnapshot = await firestore
        .collection('notifications')
        .doc(notificationRef.id)
        .get();
      payload.$toasted.success('Notification has been created!');
      dispatch('updateNotification', Object.assign({}, notificationSnapshot.data(), { id: notificationRef.id }));
    },
    async deleteNotificationRequest({ dispatch }, payload) {
      dispatch('deletingNotification', payload);
      if (payload.id != null) {
        await firestore
          .collection('notifications')
          .doc(payload.id)
          .delete();
        dispatch('deleteNotification', { id: payload.id });
        payload.$toasted.success('Notification has been deleted!');
      } else {
        dispatch('deleteNotification', {});
        payload.$toasted.error('Notification could not be deleted!');
      }
    },
    receiveNotifications({ commit }, payload) {
      commit('RECEIVED_NOTIFICATIONS', payload);
    },
    receivingNotifications({ commit }) {
      commit('RECEIVING_NOTIFICATIONS');
    },
    updateNotification({ commit }, payload) {
      commit('UPDATED_NOTIFICATION', payload);
    },
    updatingNotification({ commit }) {
      commit('UPDATING_NOTIFICATION');
    },
    deleteNotification({ commit }, payload) {
      commit('DELETED_NOTIFICATION', payload);
    },
    deletingNotification({ commit }, payload) {
      commit('DELETING_NOTIFICATION', payload);
    }
  }
};
